module.exports = __webpack_public_path__ + "static/2-96e356957e2356ac6030969699674115.jpg";